import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{#if this.readOnly}}
  <button
    class="btn btn-default disabled"
    title={{I18n "admin.site_settings.mandatory_group"}}
  >{{this.itemName}}</button>
{{else}}
  <button
    {{on "click" (fn this.selectKit.deselect this.item)}}
    aria-label={{i18n "select_kit.delete_item" name=this.itemName}}
    data-value={{this.itemValue}}
    data-name={{this.itemName}}
    type="button"
    id="{{this.id}}-choice"
    class="btn btn-default selected-choice {{this.extraClass}}"
  >
    {{d-icon "times"}}
    {{#if (has-block)}}
      {{yield}}
    {{else}}
      <span class="d-button-label">
        {{this.itemName}}
      </span>
    {{/if}}
  </button>
{{/if}}
*/
{
  "id": "t+p1S+m4",
  "block": "[[[41,[30,0,[\"readOnly\"]],[[[1,\"  \"],[10,\"button\"],[14,0,\"btn btn-default disabled\"],[15,\"title\",[28,[37,1],[\"admin.site_settings.mandatory_group\"],null]],[12],[1,[30,0,[\"itemName\"]]],[13],[1,\"\\n\"]],[]],[[[1,\"  \"],[11,\"button\"],[16,\"aria-label\",[28,[37,2],[\"select_kit.delete_item\"],[[\"name\"],[[30,0,[\"itemName\"]]]]]],[16,\"data-value\",[30,0,[\"itemValue\"]]],[16,\"data-name\",[30,0,[\"itemName\"]]],[16,1,[29,[[30,0,[\"id\"]],\"-choice\"]]],[16,0,[29,[\"btn btn-default selected-choice \",[30,0,[\"extraClass\"]]]]],[24,4,\"button\"],[4,[38,3],[\"click\",[28,[37,4],[[30,0,[\"selectKit\",\"deselect\"]],[30,0,[\"item\"]]],null]],null],[12],[1,\"\\n    \"],[1,[28,[35,5],[\"times\"],null]],[1,\"\\n\"],[41,[48,[30,1]],[[[1,\"      \"],[18,1,null],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,1],[14,0,\"d-button-label\"],[12],[1,\"\\n        \"],[1,[30,0,[\"itemName\"]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n\"]],[]]]],[\"&default\"],false,[\"if\",\"I18n\",\"i18n\",\"on\",\"fn\",\"d-icon\",\"has-block\",\"yield\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/select-kit.dd9a86fe/node_modules/select-kit/components/selected-choice.hbs",
  "isStrictMode": false
});